import { actionType } from "../actions/bybetjenterActions";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];
const bybetjenterReducer = (state = INITIAL_STATE, action) =>
  CreateNewReducer(state, action, actionType);

export default bybetjenterReducer;
